// ======================================================================
// File Name       : report
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';

export function postReportGetList(data) {
  return commonCallApi({
    path: 'report/GetList',
    data: { ...data },
  });
}

export function postReportEdit(data) {
  return commonCallApi({
    path: 'report/Edit',
    data: { ...data },
  });
}
